import { $settings } from '@/provider/settings';

const localStorageHelper = {
  setCid: (value) => {
    window.localStorage.setItem('cid', value);
  },

  getCid: () => window.localStorage.getItem('cid') || $settings.cid[0].value,

  setLocale: (value) => {
    window.localStorage.setItem('locale', value);
  },

  getLocale: () =>
    window.localStorage.getItem('locale') || $settings.languages[0].value,

  setProfile: (value) => {
    window.localStorage.setItem('profile', value);
  },

  getProfile: () => {
    const profile = window.localStorage.getItem('profile');
    return (profile && JSON.parse(profile)) || {};
  },

  clearTimestamp: () => {
    const locale = localStorageHelper.getLocale();
    window.localStorage.removeItem(`metadata-${locale}-timestamp`);
  },

  getTimestamp: () => {
    const locale = localStorageHelper.getLocale();
    const timestamp = window.localStorage.getItem(
      `metadata-${locale}-timestamp`,
    );

    // Fallback to 1970-01-01T00:00:00.000Z if no timestamp is found
    return timestamp ? JSON.parse(timestamp) : new Date(0).toISOString();
  },

  setTimestamp: (date = new Date()) => {
    const locale = localStorageHelper.getLocale();
    window.localStorage.setItem(
      `metadata-${locale}-timestamp`,
      JSON.stringify(date.toISOString()),
    );
  },

  setItem: (itemName, data) => {
    window.localStorage.setItem(itemName, JSON.stringify(data));
  },

  getItem: (itemName) =>
    JSON.parse(window.localStorage.getItem(itemName)) || {},
};

export default localStorageHelper;
